import { motion } from "framer-motion";

const AIRPORTS = [
  { code: "MRY", name: "Monterey Regional Airport", time: "~15 min" },
  { code: "SJC", name: "San José Mineta International", time: "~1 hr 30 min" },
  { code: "OAK", name: "Oakland International", time: "~2 hr" },
  { code: "SFO", name: "San Francisco International", time: "~2 hr 15 min" },
];

const DESTINATIONS = [
  { name: "Carmel-by-the-Sea", time: "~10 min" },
  { name: "17-Mile Drive", time: "On our doorstep" },
  { name: "Big Sur", time: "~1 hr" },
  { name: "Napa Valley", time: "~2 hr 45 min" },
  { name: "Lake Tahoe", time: "~4 hr" },
];

const EASE = [0.16, 1, 0.3, 1];

function Row({ label, sub, time, testid }) {
  return (
    <div
      data-testid={testid}
      className="flex items-baseline justify-between gap-4 border-b border-line py-4"
    >
      <div className="flex items-baseline gap-4">
        {sub && (
          <span className="font-mono text-xs tracking-[0.2em] text-champagne">{sub}</span>
        )}
        <span className="text-sm text-bone">{label}</span>
      </div>
      <span className="whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.2em] text-smoke">
        {time}
      </span>
    </div>
  );
}

export default function Locations() {
  return (
    <section
      id="locations"
      data-testid="locations-section"
      className="scroll-mt-20 border-t border-line py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="mb-14 flex flex-col gap-6 sm:mb-20 md:flex-row md:items-end md:justify-between"
        >
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-champagne">
              03 — Where We&apos;ll See You
            </p>
            <h2 className="mt-4 font-serif text-3xl font-light tracking-tight text-bone sm:text-5xl">
              Every arrival, <span className="italic text-champagne">timed to the minute.</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-smoke">
            From the runway at SFO to the 18th at Pebble — typical chauffeured transfer times
            from the heart of the Peninsula.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-12 md:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease: EASE }}
            data-testid="airports-list"
          >
            <p className="mb-2 font-mono text-[10px] uppercase tracking-[0.3em] text-champagne">
              Airports
            </p>
            {AIRPORTS.map((a) => (
              <Row
                key={a.code}
                label={a.name}
                sub={a.code}
                time={a.time}
                testid={`airport-${a.code.toLowerCase()}`}
              />
            ))}
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: 0.12, ease: EASE }}
            data-testid="destinations-list"
          >
            <p className="mb-2 font-mono text-[10px] uppercase tracking-[0.3em] text-champagne">
              Destinations
            </p>
            {DESTINATIONS.map((d) => (
              <Row
                key={d.name}
                label={d.name}
                time={d.time}
                testid={`destination-${d.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              />
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
